/**
 * the setting will remove the usage of the /reorders endpoint in the account menu.Which is currently used as the condition on when to show the My Brands link
 */
export const REMOVE_MY_BRANDS_ACCOUNT_MENU_CONDITION_240814 = 'REMOVE_MY_BRANDS_ACCOUNT_MENU_CONDITION_240814';
